import {
  Box,
  Loader,
  Modal,
  Tabs,
  Text,
  Button,
  Grid,
  Col,
  Flex,
} from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ClientSupportPlan from "../../../components/MAR/ClientSupportPlans";
import { getSinglePatients } from "../../../services/patient";
import { decrypt } from "../../../utils";
import useStyles from "./style";
import { FaEnvelope } from "react-icons/fa";
import {
  IconAlertTriangle,
  IconEye,
  IconEyeClosed,
  IconFileTypePdf,
} from "@tabler/icons-react";
import EditGaurdianinfo from "../../../components/Edit_client_profile/EditGaurdianinfo";
import EditPersonalInfo from "../../../components/Edit_client_profile/EditPersonalInfo";
import Editinsurance from "../../../components/Edit_client_profile/Editinsurance";
import PersonalHealthEdit from "../../../components/Edit_client_profile/PersonalHealthEdit";
import ClientNoteview from "../Note/ClientNoteview";
import ClientTaskView from "../Task/ClientTaskView";
import Document from "../../../components/Document";
import Medication from "../Medication";
import homeLocation from "../../../images/homeLocation.png";
import lightBulb from "../../../images/lightBulb.png";
import insurance from "../../../images/insurance.png";
import contact from "../../../images/contact.png";
import expand from "../../../images/expand.png";
import heart from "../../../images/heart.png";
import phone from "../../../images/phone.png";
import AddNewMedicationModal from "../../../components/AddNewMedicationModal";
import ClientInsuranceModal from "../../../components/ClientInsuranceModal";
import CareSupportModal from "../../../components/CareSupportModal";

import "./index.css";
import InsuranceCard from "../../../components/InsuranceCard/InsuranceCard";
import { getAllPlans, getSinglePlan } from "../../../services/supportplan";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ClientSummaryPDF from "../../../components/ClientSummaryPDF/ClientSummaryPDF";
import EMSFormModal from "../../../components/EMSFormModal";
import IncidentReportModal from "../../../components/IncidentReportModal";
import { getActivites } from "../../../services/activity";
import ActivitySide from "./ActivitySide";
import { TrackPageView } from "../../../config/mixpanelConfig";
import { getAllFacilitiesModal } from "../../../services";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { clearNotes } from "../../../store/reducers/note";
import UploadStaffDoc from "../../../components/StaffDetails/UploadStaffDoc";
import { isStaff } from "../../../http";
import { getAllStaffWithSignature } from "../../../services/staff";

const Client = (props) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [clientDetails, setClientDetails] = useState(null);
  const [showSSN, setShowSSN] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);
  const [openedModal, { open: openDetails, close: closeDetails }] =
    useDisclosure(false);
  const [insuranceModal, { open: openModal, close: closeModal }] =
    useDisclosure(false);
  const [careSupportModal, { open: openCareModal, close: closeCareModal }] =
    useDisclosure(false);
  const [
    personalHealthOpened,
    { open: openPersonalHealth, close: closePersonalHealth },
  ] = useDisclosure(false);
  const [
    guardianInfoOpened,
    { open: openGuardianInfo, close: closeGuardianInfo },
  ] = useDisclosure(false);
  const [insuranceOpened, { open: openInsurance, close: closeInsurance }] =
    useDisclosure(false);
  const [loading, setLoading] = useState(true);
  const [planData, setPlanData] = useState(null);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.tab || "profile");
  const { selectedClient } = useSelector((state) => state.mar);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [medicine, setMedicine] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  const [view, setView] = useState("calendar");
  const [activities, setActivities] = useState(null);
  const [activityLoading, setActivityLoading] = useState(false);
  const [emsModalOpened, setEmsModalOpened] = useState(false);
  const [incidentPromptOpened, setIncidentPromptOpened] = useState(false);
  const [incidentReportOpened, setIncidentReportOpened] = useState(false);
  const [latestEMSData, setLatestEMSData] = useState(null);
  const { profile } = useSelector((state) => state?.profile);
  const id =
    typeof location.state === "string"
      ? location.state
      : location.state?.clientId ||
        location.state?.client?.client?.id ||
        location.state?.planDoc?.client?.id;
  let notificationDoc = location.state?.notificationDoc;
  let planDoc = location.state?.planDoc;

  const editFormRef = useRef();

  const form1 = clientDetails?.form1;
  const form2 = clientDetails?.form2;

  const knownIllnessVal = clientDetails?.form1?.knownIllness;

  const diagnosisVal = clientDetails?.form1.diagnosis;

  useEffect(() => {
    if (guardianInfoOpened && form2) {
      if (form2?.noCaseManager && editFormRef?.current) {
        editFormRef.current.checked = true;
      }
    }
  }, [guardianInfoOpened, form2]);

  useEffect(() => {
    _getActivites();
    getAllStaffWithSignature();
    TrackPageView("Client");
  }, [id]);

  useEffect(() => {
    if (notificationDoc) {
      setActiveTab("documents");
      setClientDetails({
        ...notificationDoc?.client,
        form1: decrypt(notificationDoc?.client?.form1),
        form2: decrypt(notificationDoc?.client?.form2),
        form3: decrypt(notificationDoc?.client?.form3),
        name: decrypt(notificationDoc?.client?.name, false),
      });
      setLoading(false);
    }
  }, [notificationDoc, location]);

  useEffect(() => {
    if (planDoc) {
      setActiveTab("support");
      setLoading(false);
    }
  }, [planDoc, location]);

  const _getActivites = async () => {
    if (id) {
      setActivityLoading(true);
      const data = await getActivites(id);
      setActivities(data);
    }
    setActivityLoading(false);
  };

  const getData = async () => {
    let patientId;
    if (state?.notificationDoc) {
      patientId = state?.notificationDoc?.client?.id;
    } else if (state?.planDoc) {
      patientId = state?.planDoc?.client?.id;
    } else if (state?.client) {
      patientId = state?.client?.client?.id;
    } else if (state?.clientId) {
      patientId = state?.clientId;
    } else if (typeof state === "string") {
      patientId = state;
    }
    if (!patientId) {
      setLoading(false);
      return;
    }
    let res = await getSinglePatients(patientId);
    setLoading(false);
    setClientDetails(res);
  };
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   return () => {
  //     dispatch(clearNotes());
  //   };
  // }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearNotes());
    };
  }, []);

  const handleTabChange = (val) => {
    setShouldRefresh(true);
    setActiveTab(val);
    getAllFacilitiesModal("withDeleted", false);
    setTimeout(() => setActiveTab(val), 200);
    localStorage.setItem("tab", val);
  };

  const handleEMSDownloadComplete = (emsData) => {
    setLatestEMSData(emsData);
    setEmsModalOpened(false);
    setIncidentPromptOpened(true);
  };

  const openIncidentReport = () => {
    setIncidentPromptOpened(false);
    setIncidentReportOpened(true);
  };

  useEffect(() => {
    getData();
  }, [state]);

  useEffect(() => {
    const fetchPlanData = async () => {
      if (state?.planDoc) {
        const data = await getSinglePlan(state?.planDoc?.moduleId);
        setPlanData(data);
      }
    };

    fetchPlanData();
  }, [state]);

  useEffect(() => {
    if (activeTab === "medicationList") {
      getData();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "support" || activeTab === "notes") {
      if (state?.notificationDoc) {
        getAllPlans(state?.notificationDoc?.client?.id, true);
      } else if (state?.planDoc) {
        getAllPlans(state?.planDoc?.client?._id, true);
      } else {
        getAllPlans(
          typeof state === "string" ? state : state?.client?.client?.id,
          true
        );
      }
    }
  }, [activeTab]);

  const { classes } = useStyles();

  const customId = clientDetails?.id;
  const clientId = customId?.slice(-6);

  const filteredMedications = clientDetails?.form3
    ? clientDetails?.form3?.filter(
        (medicine) =>
          medicine?.discontinued === false || !("discontinued" in medicine)
      )
    : "";
  return (
    <Box className={classes.content}>
      <AppNavbar title="Client" profile={profile} />

      <AddNewMedicationModal
        opened={opened}
        onclose={(nType) => {
          close();
          setMedicine(null);
          if (isPreview) setIsPreview(false);
        }}
        data={medicine}
        title={"Chloroquine"}
        userId={clientDetails?.id}
        isPreview={isPreview}
        getClientData={getData}
      />
      <EditPersonalInfo
        opened={openedModal}
        form1={form1}
        clientDetails={clientDetails}
        setClientDetails={setClientDetails}
        onclose={(nType) => {
          closeDetails();
        }}
        title={"Edit  Client Information"}
      />
      <PersonalHealthEdit
        opened={personalHealthOpened}
        form1={form1}
        onclose={closePersonalHealth}
        setClientDetails={setClientDetails}
        title={"Edit Health Information"}
      />

      <EditGaurdianinfo
        opened={guardianInfoOpened}
        form2={clientDetails?.form2}
        setClientDetails={setClientDetails}
        // ref={editFormRef}
        onclose={closeGuardianInfo}
        title={"Edit Guardian Information"}
      />

      <Editinsurance
        opened={insuranceOpened}
        setClientDetails={setClientDetails}
        form2={form2} // Assuming you need to pass some form data
        onclose={closeInsurance}
        title={"Edit Insurance Information"}
      />

      <ClientInsuranceModal
        opened={insuranceModal}
        onClose={closeModal}
        data={clientDetails}
      />

      <CareSupportModal
        opened={careSupportModal}
        onClose={closeCareModal}
        clientDetails={clientDetails}
      />

      {loading ? (
        <Loader
          color="yellow"
          style={{
            marginTop: "190px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            left: "40%",
          }}
        />
      ) : (
        <>
          <Flex
            align="center"
            gap={5}
            m={10}
            onClick={() => {
              navigate(-1);
            }}
            style={{ cursor: "pointer", width: "fit-content" }}
          >
            <MdKeyboardArrowLeft size={30} />
            <Text fw={400} fz={14} c={"#262626"} ff={"Inter"}>
              All Clients
            </Text>
          </Flex>
          <Box className={classes.top_header}>
            {/* <Text className="client-text" size="xl" weight={600} bold>
              Client
            </Text> */}
          </Box>
          {activeTab !== "profile" && (
            <Flex
              mx={20}
              gap={8}
              align="Center"
              className={`top-client-grid ${classes.profile_container}`}
            >
              <Box>
                <img
                  src={
                    clientDetails?.imageurl
                      ? decrypt(clientDetails?.imageurl)
                      : "/assets/images/personal2.png"
                  }
                  alt="client_image"
                  className="top-image"
                />
              </Box>
              <Box>
                <p className="client-name-label">Client Name</p>
                <h2 className="top-client-name">{clientDetails?.name}</h2>
                <p className="top-client-id">
                  {clientDetails?.id?.slice(0, 6)}
                </p>
              </Box>
            </Flex>
          )}

          <Box px={20} color="#262626">
            <Tabs
              defaultValue={activeTab}
              value={activeTab}
              className={classes.tabs}
            >
              <Tabs.List>
                <Tabs.Tab
                  value="profile"
                  onClick={() => {
                    _getActivites();
                    handleTabChange("profile");
                  }}
                >
                  Facesheet
                </Tabs.Tab>
                <Tabs.Tab
                  value="support"
                  id="care"
                  onClick={() => handleTabChange("support")}
                >
                  Care Plan
                </Tabs.Tab>

                {/* {((!profile?.user?.type && !profile?.user?.role) ||
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.medication === true) && ( */}
                {((!profile?.user?.type && !profile?.user?.role) ||
                  // Rule 2: permissions object missing OR medication field missing
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.medication === undefined ||
                  // Rule 3: medication explicitly true
                  profile?.user?.permissions?.medication === true) && (
                  <Tabs.Tab value="mar" onClick={() => handleTabChange("mar")}>
                    MAR
                  </Tabs.Tab>
                )}
                {((!profile?.user?.type && !profile?.user?.role) ||
                  // Rule 2: permissions object missing OR note field missing
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.note === undefined ||
                  // Rule 3: note explicitly true
                  profile?.user?.permissions?.note === true) && (
                  <Tabs.Tab
                    value="notes"
                    onClick={() => handleTabChange("notes")}
                  >
                    Notes
                  </Tabs.Tab>
                )}
                {/* {((!profile?.user?.type && !profile?.user?.role) ||
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.note === true) && (
                  <Tabs.Tab
                    value="notes"
                    onClick={() => handleTabChange("notes")}
                  >
                    Notes
                  </Tabs.Tab>
                )} */}
                {((!profile?.user?.type && !profile?.user?.role) ||
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.task === undefined ||
                  profile?.user?.permissions?.task === true) && (
                  <Tabs.Tab
                    value="tasks"
                    onClick={() => handleTabChange("tasks")}
                  >
                    Task
                  </Tabs.Tab>
                )}
                <Tabs.Tab
                  value="documents"
                  onClick={() => handleTabChange("documents")}
                >
                  Documents
                </Tabs.Tab>
              </Tabs.List>

              <Tabs.Panel
                value="profile"
                style={{
                  backgroundColor: "#F2F2F2",
                  height: "auto",
                  padding: "15px 0",
                }}
                className="profile-tab"
              >
                {/* download client summary and client chart buttons */}
                {!isStaff(profile?.user?.role) ? (
                  <Flex
                    className={classes.buttonParent}
                    gap={12}
                    justify="flex-end"
                    wrap="wrap"

                  >
                    <PDFDownloadLink
                      document={
                        <ClientSummaryPDF
                          clientData={clientDetails}
                          activities={activities}
                          facilityName={profile?.facility?.name}
                          facilityPhoto={profile?.facility?.imageurl ? decrypt(profile.facility.imageurl) : null}
                        />
                      }
                      fileName={`${
                        clientDetails?.form1?.name ?? "Client Summary"
                      }.pdf`}
                    >
                      <Button
                        className="download-client"
                        variant="default"
                        leftIcon={<IconFileTypePdf size={18} stroke={1.8} />}
                        styles={{
                          root: {
                            marginBottom: 10,
                            height: 46,
                            borderRadius: 12,
                            padding: "0 22px",
                            background: "#ffffff",
                            color: "#26303c",
                            border: "1px solid #d7dce5",
                            fontWeight: 600,
                            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
                          },
                        }}
                      >
                        Download Client Summary
                      </Button>
                    </PDFDownloadLink>
                    <Button
                      variant="outline"
                      color="red"
                      leftIcon={<IconAlertTriangle size={16} stroke={1.8} />}
                      styles={{
                        root: {
                          marginBottom: 10,
                          height: 46,
                          borderRadius: 12,
                          padding: "0 22px",
                          fontWeight: 600,
                          background: "#ffffff",
                          color: "#ff5b57",
                          border: "1px solid #ff5b57",
                          boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
                        },
                      }}
                      onClick={() => setEmsModalOpened(true)}
                    >
                      EMS Form
                    </Button>
                  </Flex>
                ) : null}
                {/* patient details */}
                <div className="patient-details-parent">
                  <Grid>
                    <Col
                      sm={12}
                      lg={2}
                      xl={clientDetails?.imageurl ? 1.4 : 1.6}
                    >
                      <img
                        src={
                          clientDetails?.imageurl
                            ? decrypt(clientDetails?.imageurl)
                            : "/assets/images/personal2.png"
                        }
                        alt="client_image"
                        className={
                          clientDetails?.imageurl
                            ? "client-image"
                            : "avatar-image"
                        }
                      />
                    </Col>
                    <Col
                      span={12}
                      sm={8}
                      lg={6}
                      xl={clientDetails?.imageurl ? 6.6 : 6.4}
                    >
                      <div>
                        <h5 className="client-name">{clientDetails?.name}</h5>
                        <p className="client-id figma-grey-color">
                          {clientDetails?.id?.slice(18, 24)}
                        </p>
                      </div>
                      <div>
                        <Grid justify="Flex-start">
                          <Col span={12} sm={6} lg={1}>
                            <p className="gender font-size">
                              {clientDetails?.form1?.gender}
                            </p>
                          </Col>
                          <Col span={12} sm={6} lg={3}>
                            <p className="client-data font-size">
                              {moment(clientDetails?.form1?.dob).format(
                                "MM/DD/YYYY"
                              )}

                              <span className="relative-date">
                                (
                                {moment(clientDetails?.form1?.dob)
                                  ?.fromNow()
                                  ?.replace("ago", "")
                                  ?.trim()}
                                )
                              </span>
                            </p>
                          </Col>
                          <Col span={12} sm={6} lg={2}>
                            <p className="client-data font-size">
                              Height:{" "}
                              <span>{clientDetails?.form1?.height || "-"}</span>
                            </p>
                          </Col>
                          <Col span={12} sm={6} lg={2.5}>
                            <p className="client-data font-size">
                              Weight:{" "}
                              {clientDetails?.form1?.weight ? (
                                <span>{clientDetails.form1.weight} lbs</span>
                              ) : (
                                "-"
                              )}
                            </p>
                          </Col>
                        </Grid>
                      </div>
                      <div>
                        <Grid align="Center" justify="Flex-start">
                          <Col
                            span={8}
                            sm={6}
                            md={6}
                            lg={5}
                            className="ssn-parent"
                          >
                            <div
                              className={classes.text}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "70%",
                                fontSize: "small",
                              }}
                            >
                              SSN:{" "}
                              {`${
                                showSSN
                                  ? (!profile?.user?.role &&
                                      !profile?.user?.type) ||
                                    (profile?.user?.role === "admin" &&
                                      profile?.user?.type === "staff")
                                    ? decrypt(
                                        clientDetails?.form1
                                          ?.socialSecurityNumber,
                                        false
                                      )
                                    : `*****${decrypt(
                                        clientDetails?.form1
                                          ?.socialSecurityNumber,
                                        false
                                      )?.slice(-4)}`
                                  : "*".repeat(4)
                              }`}
                              {showSSN ? (
                                <IconEye
                                  color="#FFBA45"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setShowSSN((p) => !p)}
                                />
                              ) : (
                                <IconEyeClosed
                                  color="#FFBA45"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setShowSSN((p) => !p)}
                                />
                              )}
                            </div>
                          </Col>
                          <Col
                            span={12}
                            md={6}
                            className="ssn-parent font-size"
                          >
                            <span className="font-weight-500">
                              Admission Date:
                              <span className="figma-grey-color date-margin-left">
                                {moment(
                                  clientDetails?.form1?.admissionDate
                                ).format("MM/DD/YYYY")}
                              </span>
                            </span>
                          </Col>
                        </Grid>
                      </div>
                      <div className="address font-size">
                        <img
                          className="home-location"
                          src={homeLocation}
                          alt="home location item"
                        />
                        <span className="figma-grey-color font-weight-500">
                          {clientDetails?.form1?.currentAddress ||
                            "No address"}
                        </span>
                      </div>
                      <div className="statement">
                        <small className="font-weight-500 about-client">
                          {clientDetails?.form1?.personalPreference ||
                            "No preferences"}
                        </small>
                      </div>

                      {/* Other Locations */}
                      <div style={{ marginTop: 12 }}>
                        <p className="font-weight-500 font-size" style={{ marginBottom: 6 }}>Other Locations</p>
                        {clientDetails?.form1?.otherLocations?.length > 0
                          ? clientDetails.form1.otherLocations.map((loc, i) => (
                              <div key={i} style={{ marginBottom: 6, padding: "6px 10px", background: "#F9FAFB", border: "1px solid #E4E7EC", borderRadius: 8 }}>
                                <span style={{ fontSize: 11, fontWeight: 600, color: "#F79009", marginRight: 6 }}>{loc.label}</span>
                                <span className="figma-grey-color" style={{ fontSize: 12 }}>
                                  {[loc.address, loc.city, loc.state, loc.zipCode].filter(Boolean).join(", ")}
                                </span>
                              </div>
                            ))
                          : <span className="figma-grey-color" style={{ fontSize: 12 }}>No other locations added</span>
                        }
                      </div>
                    </Col>
                    <Col span={12} sm={12} lg={4} xl={4}>
                      <div className="diagnosis-parent">
                        <p className="font-weight-500 mb-2 level-of-care font-size level-of-care">
                          Level of Care
                        </p>
                        {clientDetails?.form1?.levelofcare ? (
                          <div className="label">
                            {clientDetails?.form1?.levelofcare}
                          </div>
                        ) : (
                          <button className="no-level-of-care">
                            No Level of Care
                          </button>
                        )}

                        <p className="font-weight-500 mb-0 font-size diagnosis">
                          Diagnosis
                        </p>
                        {/* <Grid justify="Flex-end" className="known-illness"> */}
                        {Array.isArray(clientDetails?.form1?.diagnosis) &&
                        clientDetails?.form1?.diagnosis?.length > 0 ? (
                          clientDetails?.form1?.diagnosis?.map(
                            (item, index) => (
                              <button key={index} className="illness-child">
                                {item.name}
                                {/* {typeof item === "object"
                                  ? item?.illness?.length === 0
                                    ? item?.contagious
                                    : item?.illness
                                  : item} */}
                                {/* {item} */}
                              </button>
                            )
                          )
                        ) : diagnosisVal?.length > 0 ? (
                          diagnosisVal?.map((item, index) => (
                            <button key={index} className="illness-child">
                              {item.name}
                            </button>
                          ))
                        ) : (
                          <button className="no-diagnosis">No Diagnosis</button>
                        )}
                        {/* </Grid> */}

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "baseline",
                            height: "100%",
                          }}
                        >
                          {!isStaff(profile?.user?.role) ? (
                            <button
                              id="client-personal-details"
                              onClick={() => {
                                navigate("/home/patient", {
                                  state: {
                                    clientDetails: clientDetails,
                                    formName: "personalInfo",
                                    edit: true,
                                    disable: true,
                                  },
                                });
                              }}
                              className="edit-button figma-grey-color font-weight-500"
                            >
                              Edit
                            </button>
                          ) : null}
                        </div>
                      </div>
                    </Col>
                  </Grid>
                </div>
                <div className="multiple-sections">
                  <Grid>
                    <Col span={12} lg={7.5}>
                      {/* INSURANCE */}
                      <div className="insurance-parent">
                        <div className="insurance-header">
                          <div>
                            <img
                              src={insurance}
                              alt="InsuranceImage"
                              className="insurance-img"
                            />
                            <h2 className="insurance-text">Insurance</h2>
                          </div>
                          <div>
                            {!isStaff(profile?.user?.role) ? (
                              <button
                                className="insurance-edit"
                                onClick={() => {
                                  navigate("/home/patient", {
                                    state: {
                                      clientDetails: clientDetails,
                                      formName: "insuranceInfo",
                                      edit: true,
                                      disable: true,
                                    },
                                  });
                                }}
                              >
                                Edit
                              </button>
                            ) : null}
                            <button
                              id="insurance-expand"
                              className="expand-button"
                              onClick={() => openModal()}
                            >
                              <img
                                src={expand}
                                alt="ExpandImage"
                                className="expand-image"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="insurance-card-parent">
                          <div className="insurance-cards-flex">
                            {clientDetails?.form2?.insurance ? (
                              clientDetails?.form2?.insurance?.map(
                                (data, index) => (
                                  <div
                                    key={index}
                                    className={
                                      data?.type != "medical"
                                        ? "insuranceCompParent"
                                        : ""
                                    }
                                  >
                                    <InsuranceCard
                                      type={data?.type}
                                      effectiveDate={
                                        moment(data?.effectiveDate).isValid()
                                          ? moment(data?.effectiveDate).format(
                                              "MM/DD/YYYY"
                                            )
                                          : moment(
                                              clientDetails?.form2
                                                ?.effectiveDate
                                            ).isValid()
                                          ? moment(
                                              clientDetails?.form2
                                                ?.effectiveDate
                                            ).format("MM/DD/YYYY")
                                          : ""
                                      }
                                      // effectiveDate={
                                      //   moment(data?.effectiveDate).format(
                                      //     "MM/DD/YYYY"
                                      //   ) ||
                                      //   moment(
                                      //     clientDetails?.form2?.effectiveDate
                                      //   ).format("MM/DD/YYYY")
                                      // }
                                      groupNumber={
                                        data?.groupNumber ||
                                        clientDetails?.form2?.groupNumber
                                      }
                                      subscriberName={
                                        data?.subscriberName ||
                                        clientDetails?.form2?.subscriberName
                                      }
                                      identificationNumber={
                                        data?.identificationNumber
                                      }
                                      insuranceCompanyName={
                                        data?.providerName ||
                                        clientDetails?.form2
                                          ?.insuranceCompanyName
                                      }
                                      anotherType={data?.insuranceType}
                                    />
                                  </div>
                                )
                              )
                            ) : (
                              <InsuranceCard
                                type={"Medical"}
                                effectiveDate={moment(
                                  clientDetails?.form2?.effectiveDate
                                ).format("MM/DD/YYYY")}
                                groupNumber={clientDetails?.form2?.groupNumber}
                                subscriberName={
                                  clientDetails?.form2?.subscriberName
                                }
                                identificationNumber={""}
                                insuranceCompanyName={
                                  clientDetails?.form2?.insuranceCompanyName
                                }
                                anotherType={""}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      {/* CARE & SUPPORT */}
                      <div className="care-parent">
                        <div className="care-header">
                          <div>
                            <img
                              src={contact}
                              alt="Care&SupportImage"
                              className="care-img"
                            />
                            <h2 className="care-text">Care & Support</h2>
                          </div>
                          <div>
                            {!isStaff(profile?.user?.role) ? (
                              <button
                                id="care-support-edit"
                                className="care-edit"
                                onClick={() => {
                                  navigate("/home/patient", {
                                    state: {
                                      clientDetails: clientDetails,
                                      formName: "careSupportInfo",
                                      edit: true,
                                      disable: true,
                                    },
                                  });
                                }}
                              >
                                Edit
                              </button>
                            ) : null}

                            <button
                              className="expand-button"
                              onClick={() => openCareModal()}
                            >
                              <img
                                src={expand}
                                alt="ExpandImage"
                                className="expand-image"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="care-box-parent">
                          {/* Care and support field name */}
                          <div className="box-1">
                            <small className="display-block font-weight-500 figma-grey-color line-height">
                              Guardian
                            </small>

                            <small className="display-block font-weight-500 figma-grey-color line-height">
                              Case Manager
                            </small>

                            <small className="display-block font-weight-500 figma-grey-color line-height">
                              PRIMARY CARE PHYSICIAN
                            </small>

                            <small className="display-block font-weight-500 figma-grey-color line-height">
                              PHARMACY
                            </small>

                            {clientDetails?.form2?.additionalProvider ? (
                              clientDetails?.form2?.additionalProvider?.map(
                                (item, index) => (
                                  <small
                                    key={index}
                                    className="display-block font-weight-500 figma-grey-color line-height"
                                  >
                                    {item?.providerType?.length > 23
                                      ? `${item?.providerType.slice(0, 23)}...`
                                      : item?.providerType}
                                  </small>
                                )
                              )
                            ) : (
                              <div></div>
                            )}
                          </div>
                          {/* Care and support names */}
                          <div className="box-2">
                            <small className="display-block font-weight-500 line-height">
                              {clientDetails?.form2?.emergencyContactName ? (
                                clientDetails?.form2?.emergencyContactName
                              ) : (
                                <div>None</div>
                              )}
                            </small>
                            <small className="display-block font-weight-500 line-height">
                              {clientDetails?.form2?.caseManagerName ? (
                                clientDetails?.form2?.caseManagerName
                              ) : (
                                <div>None</div>
                              )}
                            </small>
                            <small className="display-block font-weight-500 line-height">
                              {clientDetails?.form2?.pcpName ? (
                                clientDetails?.form2?.pcpName
                              ) : (
                                <div>None</div>
                              )}
                            </small>
                            <small className="display-block font-weight-500 line-height">
                              {clientDetails?.form2?.pharmacyName ? (
                                clientDetails?.form2?.pharmacyName
                              ) : (
                                <div>None</div>
                              )}
                            </small>
                            {clientDetails?.form2?.additionalProvider ? (
                              clientDetails?.form2?.additionalProvider?.map(
                                (item, index) => (
                                  <small
                                    key={index}
                                    className="display-block font-weight-500 line-height"
                                  >
                                    {item?.providerName
                                      ? item?.providerName
                                        ? item?.providerName
                                        : item?.providerFirstName +
                                          item?.providerLastName
                                      : ""}
                                  </small>
                                )
                              )
                            ) : (
                              <div></div>
                            )}
                          </div>
                          {/* Care and support call */}
                          <div className="box-3">
                            {clientDetails?.form2
                              ?.emergencyContactPhoneNumber ? (
                              <small className="display-block font-weight-500 line-height">
                                <img
                                  src={phone}
                                  alt="Call"
                                  className="call-icon"
                                />
                                {
                                  clientDetails?.form2
                                    ?.emergencyContactPhoneNumber
                                }
                              </small>
                            ) : (
                              <div>None</div>
                            )}

                            {clientDetails?.form2?.caseManagerPhoneNumber ? (
                              <small className="display-block font-weight-500 line-height">
                                <img
                                  src={phone}
                                  alt="Call"
                                  className="call-icon"
                                />
                                {clientDetails?.form2?.caseManagerPhoneNumber}
                              </small>
                            ) : (
                              <div>None</div>
                            )}
                            {clientDetails?.form2?.pcpPhoneNumber ? (
                              <small className="display-block font-weight-500 line-height">
                                <img
                                  src={phone}
                                  alt="Call"
                                  className="call-icon"
                                />
                                {clientDetails?.form2?.pcpPhoneNumber}
                              </small>
                            ) : (
                              <div>None</div>
                            )}

                            {clientDetails?.form2?.pharmacyPhoneNumber ? (
                              <small className="display-block font-weight-500 line-height">
                                <img
                                  src={phone}
                                  alt="Call"
                                  className="call-icon"
                                />
                                {clientDetails?.form2?.pharmacyPhoneNumber}
                              </small>
                            ) : (
                              <div>None</div>
                            )}

                            {clientDetails?.form2?.additionalProvider &&
                            clientDetails?.form2?.additionalProvider?.length > 0
                              ? clientDetails?.form2?.additionalProvider?.map(
                                  (item, index) =>
                                    item?.providerPhone ? (
                                      <small
                                        key={index}
                                        className="display-block font-weight-500 line-height"
                                      >
                                        <img
                                          src={phone}
                                          alt="Call"
                                          className="call-icon"
                                        />
                                        {item?.providerPhone}
                                      </small>
                                    ) : (
                                      <div></div>
                                    )
                                )
                              : null}
                          </div>
                          {/* Care and support emails*/}
                          <div className="box-4">
                            {clientDetails?.form2?.emergencyContactEmail ? (
                              <small className="display-block font-weight-500 line-height">
                                <FaEnvelope style={{ marginRight: "7px" }} />
                                {clientDetails?.form2?.emergencyContactEmail}
                              </small>
                            ) : (
                              <div>None</div>
                            )}
                            {clientDetails?.form2?.caseManagerEmail ? (
                              <small className="display-block font-weight-500 line-height">
                                <FaEnvelope style={{ marginRight: "7px" }} />
                                {clientDetails?.form2?.caseManagerEmail}
                              </small>
                            ) : (
                              <div>None</div>
                            )}
                            {clientDetails?.form2?.pcpEmail ? (
                              <small className="display-block font-weight-500 line-height">
                                <FaEnvelope style={{ marginRight: "7px" }} />
                                {clientDetails?.form2?.pcpEmail}
                              </small>
                            ) : (
                              <div>None</div>
                            )}
                            {clientDetails?.form2?.pharmacyEmail ? (
                              <small className="display-block font-weight-500 line-height">
                                <FaEnvelope style={{ marginRight: "7px" }} />
                                {clientDetails?.form2?.pharmacyEmail}
                              </small>
                            ) : (
                              <div>None</div>
                            )}
                            {clientDetails?.form2?.additionalProvider &&
                            clientDetails?.form2?.additionalProvider.length > 0
                              ? clientDetails.form2.additionalProvider.map(
                                  (item, index) =>
                                    item.providerEmail ? (
                                      <small
                                        key={index}
                                        className="display-block font-weight-500 line-height"
                                      >
                                        <FaEnvelope
                                          style={{ marginRight: "7px" }}
                                        />
                                        {item.providerEmail}
                                      </small>
                                    ) : (
                                      <div></div>
                                    )
                                )
                              : null}
                          </div>
                        </div>
                      </div>
                      {/* HEALTH */}
                      <div className="health-parent">
                        <div className="health-header">
                          <div>
                            <img
                              src={heart}
                              alt="Healthimage"
                              className="health-img"
                            />
                            <h2 className="health-text">Health</h2>
                          </div>
                          <div>
                            {!isStaff(profile?.user?.role) ? (
                              <button
                                className="health-edit"
                                id="health-edit-click"
                                onClick={() => {
                                  navigate("/home/patient", {
                                    state: {
                                      clientDetails: clientDetails,
                                      formName: "healthInfo",
                                      edit: true,
                                      disable: true,
                                    },
                                  });
                                }}
                              >
                                Edit
                              </button>
                            ) : null}
                          </div>
                        </div>
                        <div>
                          {/* Level of Need */}
                          <div className="medication-parent">
                            <p className="client-medication">Level of Need</p>
                            <Box className="medicineConteiner">
                              {clientDetails?.form1?.levelofneed ? (
                                <p>{clientDetails?.form1?.levelofneed}</p>
                              ) : (
                                <small>No Level of Need</small>
                              )}
                            </Box>
                          </div>
                          {/* Active Medication */}
                          <div className="medication-parent">
                            <p className="client-medication">
                              Active Medication
                            </p>
                            <Box className="medicineConteiner">
                              {filteredMedications &&
                              filteredMedications.length > 0 ? (
                                filteredMedications.map((medicine, index) => (
                                  <p key={index} className="medicine">
                                    {`${medicine?.medicationName} ${medicine?.dosage} ${medicine?.unit} ${medicine?.frequency}`}
                                    <p className="medication-administered">{`${medicine?.medicationadministered} ${medicine?.dosageForm} ${medicine?.ingestionMode}`}</p>
                                  </p>
                                ))
                              ) : (
                                <small>No Medication</small>
                              )}
                            </Box>
                          </div>
                          {/* Allergies */}
                          <div className="medication-parent">
                            <p className="allergies">Allergies</p>

                            {clientDetails?.form1?.knownAllergies?.length >
                            0 ? (
                              clientDetails?.form1?.knownAllergies
                                ?.filter((item) => item.trim() !== "")
                                ?.map((item, index) => (
                                  <button key={index} className="allergy">
                                    {item}
                                  </button>
                                ))
                            ) : (
                              <small>No Allergy</small>
                            )}
                          </div>
                          {/* Dietary Restrictions */}
                          <div className="medication-parent">
                            <p className="dietary-restrictions">
                              Dietary Restrictions
                            </p>
                            {clientDetails?.form1?.dietaries?.length != 0 ? (
                              clientDetails?.form1?.dietaries
                                ?.filter((item) => item != "")
                                ?.map((item, index) => (
                                  <button key={index} className="restriction">
                                    {item}
                                  </button>
                                ))
                            ) : (
                              <small>No Restriction</small>
                            )}
                          </div>

                          {/* Provider Services */}
                          <div className="medication-parent">
                            <p className="dietary-restrictions">
                              Provider Services
                            </p>
                            {clientDetails?.form1?.services?.length != 0 ? (
                              clientDetails?.form1?.services
                                ?.filter((item) => item != "")
                                ?.map((item, index) => (
                                  <button key={index} className="restriction">
                                    {item?.servicetitle}
                                  </button>
                                ))
                            ) : (
                              <small>No Services</small>
                            )}
                          </div>

                          {/* Diagnosis Summary */}
                          <div className="textarea-parent">
                            <fieldset className="contact-fieldset">
                              <legend>Diagnosis Summary</legend>
                              <p className="diagnosis-text">
                                {clientDetails?.form1?.summary}
                              </p>
                            </fieldset>
                          </div>
                        </div>
                      </div>
                    </Col>
                    {/* Activity */}
                    <Col span={12} lg={4.5}>
                      <div className="timeline-parent">
                        <div className="activity-parent">
                          <img
                            className="light-bulb"
                            src={lightBulb}
                            alt="Activity icon"
                          />
                          <h2 className="activity-text">Activity</h2>
                        </div>
                        <div className="timeline-div">
                          {activityLoading ? (
                            <Box
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "auto",
                                height: "700px",
                              }}
                            >
                              <Loader color="yellow" size={"md"} />
                            </Box>
                          ) : (
                            <ActivitySide
                              activities={activities}
                              isActivity={true}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  </Grid>
                </div>
              </Tabs.Panel>
              <Tabs.Panel value="support">
                <ClientSupportPlan
                  client={
                    state?.planDoc
                      ? state?.planDoc?.client?.id
                      : state?.client
                      ? state?.client?.client?.id
                      : state
                  }
                  clientDetails={clientDetails}
                  planData={planData}
                />
              </Tabs.Panel>
              {
                // Rule 1: No type and no role
                ((!profile?.user?.type && !profile?.user?.role) ||
                  // Rule 2: permissions object missing OR note field missing
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.note === undefined ||
                  // Rule 3: note explicitly true
                  profile?.user?.permissions?.note === true) && (
                  <Tabs.Panel value="notes">
                    <ClientNoteview userId={id} activeTab={activeTab} />
                  </Tabs.Panel>
                )
              }

              {/* {((!profile?.user?.type && !profile?.user?.role) ||
                !profile?.user?.permissions ||
                !profile?.user?.permissions?.hasOwnProperty("note") ||
                profile?.user?.permissions?.note === true) && (
                <Tabs.Panel value="notes">
                  <ClientNoteview userId={id} activeTab={activeTab} />
                </Tabs.Panel>
              )} */}
              {/* (!profile?.user?.permissions?.note && */}
              {
                // Rule 1: No type and no role
                ((!profile?.user?.type && !profile?.user?.role) ||
                  // Rule 2: permissions object missing OR medication field missing
                  !profile?.user?.permissions ||
                  profile?.user?.permissions?.medication === undefined ||
                  // Rule 3: medication explicitly true
                  profile?.user?.permissions?.medication === true) && (
                  <Tabs.Panel value="mar">
                    <Medication userId={id} tabName={"mar"} />
                  </Tabs.Panel>
                )
              }
              {((!profile?.user?.type && !profile?.user?.role) ||
                !profile?.user?.permissions ||
                profile?.user?.permissions?.task === undefined ||
                profile?.user?.permissions?.task === true) && (
                <Tabs.Panel value="tasks">
                  <ClientTaskView userId={id} activeTab={activeTab} />
                </Tabs.Panel>
              )}
              <Tabs.Panel value="documents">
                <Document
                  client={
                    notificationDoc?.client?.id
                      ? notificationDoc.client.id
                      : planDoc?.client?.id
                      ? planDoc.client.id
                      : id
                  }
                />
              </Tabs.Panel>
            </Tabs>
            <EMSFormModal
              opened={emsModalOpened}
              onClose={() => setEmsModalOpened(false)}
              clientDetails={clientDetails}
              profile={profile}
              planData={planData}
              onDownloadComplete={handleEMSDownloadComplete}
            />
            <Modal
              opened={incidentPromptOpened}
              onClose={() => setIncidentPromptOpened(false)}
              centered
              title="Complete Incident Report?"
              size="md"
              overlayProps={{ blur: 3 }}
              transitionProps={{ duration: 200 }}
              radius="md"
              zIndex={1000}
            >
              <Text size="sm" color="dimmed" mb={18}>
                The EMS form has been downloaded. Do you want to complete an
                incident report now?
              </Text>
              <Flex justify="flex-end" gap={12}>
                <Button
                  variant="default"
                  onClick={() => setIncidentPromptOpened(false)}
                >
                  No
                </Button>
                <Button
                  onClick={openIncidentReport}
                  styles={{
                    root: {
                      background: "#f0b10a",
                      borderColor: "#f0b10a",
                      color: "#ffffff",
                      fontWeight: 600,
                    },
                  }}
                >
                  Yes
                </Button>
              </Flex>
            </Modal>
            <IncidentReportModal
              opened={incidentReportOpened}
              onClose={() => setIncidentReportOpened(false)}
              clientDetails={clientDetails}
              profile={profile}
              emsData={latestEMSData}
            />
          </Box>
        </>
      )}
      {activeTab === "documents" && notificationDoc ? (
        <UploadStaffDoc
          selectedFolder={notificationDoc?.metadata?.folder}
          userId={notificationDoc?.client?.id}
          userType={notificationDoc?.userType}
          isDocument={true}
          uploadedFiles={notificationDoc?.metadata?.file}
          isnotificationdoc={true}
        />
      ) : null}
    </Box>
  );
};

export default Client;
